import { useRef as r, useLayoutEffect as e } from "react";

import { useSyncExternalStore as o } from "use-sync-external-store/shim";

import t from "../../models/main/index.js";

const s = s => {
    const n = r().current ||= new t(s), m = o(n.on, n._getTransformedValue, n._getTransformedValue);
    return e((() => {
        s && n.set(s);
    })), e((() => n.syncCursor()), [ m ]), n;
};

export { s as default };
//# sourceMappingURL=index.js.map
